// Переключение кнопок с адресами над картой
itsoftApp.createModule("yaMapCustom", function() {

    if ($(".contact-map").length) {

        $(".contact-map__button").click(function() {
            if (!$(this).hasClass("is-active")) {
                $(".contact-map__button").removeClass("is-active");
                $(this).addClass("is-active");
            }
        });

    }

});
